import store from '~/store/store'

export default (async function handler () {
  this.text = this.$tf('Sending petition')
  this.actions = [
    {
      title: this.$tf('Go back to my account'),
      color: 'primary',
      callback () {
        this.$router.push('/myaccount')
      }
    }
  ]
  this.loading = true

  try {
    await this.$services.user.verify.email.check(this.$route.query.token)
    this.text = this.$tf('Your email has been verified')
  } catch (response) {
    await store.dispatch('session/loadAccountData').then(response => {
      if (response && response.email !== '' && response.email_verified) {
        this.text = this.$tf('Your email has been verified')
      } else {
        this.text = this.$tf('Something went wrong verifying you email')
        this.text += `<br/>` + this.$tf('Try again later')
      }
    })
  } finally {
    if (this.text === '') {
      this.text = this.$tf('Something went wrong verifying you email')
      this.text += `<br/>` + this.$tf('Try again later')
    }
    this.loading = false
  }
})



// WEBPACK FOOTER //
// ./src/components/views/simple-api-requests/request-handlers/VerifyEmail.js